/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImportRequest } from '../models/ImportRequest';
import type { ParseResponse } from '../models/ParseResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ManagementService {
    /**
     * @param requestBody
     * @returns any File imported successfully
     * @throws ApiError
     */
    public static postManagementImport(
        requestBody: ImportRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/management/import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formData
     * @returns ParseResponse File parsed successfully
     * @throws ApiError
     */
    public static postManagementParse(
        formData: {
            file: Blob;
        },
    ): CancelablePromise<ParseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/management/parse',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
